import React from "react";
import { StyledContainerRow } from "../../../components/ModalComponents/StyledModalComponents";
import SleeperFirmnessModal from "./SleeperFirmnessModal";

import useMediaQuery from "@mui/material/useMediaQuery";

const EvrSleeperFirmnessModal = () => {
  return (
    <StyledContainerRow className="row w-100">
      <SleeperFirmnessModal></SleeperFirmnessModal>
    </StyledContainerRow>
  );
};

export default EvrSleeperFirmnessModal;
